import React, { Component } from 'react';

import './shareFBTwitter.css';
import './ic_twitter.svg';
import './ic_facebook.svg';

export default class shareFBTwitter extends Component {
  render() {
    return (
      <div className='share-buttons'>
        <a id='game-twitter-btn-end' className='share-buttons__button share-buttons__button--twitter' href='http://twitter.com/intent/tweet?text=A%20simple%20game%20of%20higher%20or%20lower%20using%20Google%20searches.%20Play%20%40HigherLowerGame%20now!%20http://bit.ly/HigherLowerGame' target='_blank' rel='noopener noreferrer'>Tweet</a>
        <a id='game-facebook-btn-end' className='share-buttons__button share-buttons__button--facebook' href='https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fwww.higherlowergame.com' target='_blank' rel='noopener noreferrer'>Share</a>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/share-fb-twitter/shareFBTwitter.js